import Cookies from 'js-cookie';
import {clearCachedProfile} from './profileCache';

export const TOKEN_KEY = 'token';

const COOKIE_OPTIONS = {
    expires: 30,
    path: '/',
    sameSite: 'Lax',
};

export function getToken() {
    return Cookies.get(TOKEN_KEY) || null;
}

export function setToken(token) {
    Cookies.set(TOKEN_KEY, token, COOKIE_OPTIONS);
}

export function clearToken() {
    Cookies.remove(TOKEN_KEY, {path: '/'});
    Cookies.remove(TOKEN_KEY);

    ['/login', '/orders', '/profile'].forEach((path) => {
        Cookies.remove(TOKEN_KEY, {path});
    });
}

export function logoutAndRedirect() {
    const token = getToken();
    clearToken();
    clearCachedProfile();

    const baseURL = process.env.REACT_APP_BASE_URL;
    if (token && baseURL) {
        fetch(`${baseURL}/auth/restaurant/logout`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${token}`,
            },
            keepalive: true,
        }).catch(() => {});
    }

    window.location.replace('/login');
}
